var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouncement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 9.125C4.125 9.125 8.5 9.75 10.375 11.625H11C11.3452 11.625 11.625 11.3452 11.625 11V7.21063C12.1641 7.07188 12.5625 6.58244 12.5625 6C12.5625 5.41756 12.1641 4.92812 11.625 4.78937V1C11.625 0.654825 11.3452 0.375 11 0.375H10.375C8.5 2.25 4.125 2.875 4.125 2.875H1.625C0.934644 2.875 0.375 3.43464 0.375 4.125V7.875C0.375 8.56538 0.934644 9.125 1.625 9.125H2.25L2.875 12.25H4.125V9.125ZM5.375 3.91325C5.80206 3.82162 6.32969 3.69496 6.89956 3.52733C7.94844 3.21884 9.28125 2.73289 10.375 1.98411V10.0159C9.28125 9.26713 7.94844 8.78119 6.89956 8.47269C6.32969 8.30506 5.80206 8.17838 5.375 8.08675V3.91325ZM1.625 4.125H4.125V7.875H1.625V4.125Z",
    fill: "#2D9F75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/announcement.c40e0df683f6168ef708f6c9e7f8dfc0.svg";
export { ForwardRef as ReactComponent };